module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABZElEQVR4Xu2YQUoEMRRE5zZecU7kxot4HVfiSsmipeeRxKRT3YNUPahNJZHPS6AHb9/m3Fi4EQEs3IgAFm5EAAs3IoCFGxHAwo0IYOFGBLBwIwJYKHl5vf/m/v7G5SZl7/7smcgFfHx9PgxfSwvuY8rfViMVwJvrhXC9lZmXNIJMwMjNMxvs/4ryJcgEcMiRKM6u8lQBK1EhEcDhroqCCGBxBA52VRRIBMx8/lRRfQ4lAgoccCSKs6tEAIsVOGQvhOu9KJEKKHDYWlpwXy1q5AI2OPjM8Dw3c3aWCGCxCgevpQX31aJGKoDD9kK43osSmQAOORLF2VUigMUR7H8Kc7iroiACWByBg10VBRIBBQ53dlQ8VYDi7CoyAfb/Fi/MfA4J11tRff42pAIKIy+hBfcxypvfkAvYsx9+5ub4ks7kVAH/gQhg4UYEsHAjAli4EQEs3IgAFm5EAAs3IoCFGxHAwo0fnFck/rxf9qQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencyIcon/CLV.png
// module id = NWK/
// module chunks = 1